<i18n>
{
  "fr": {
      "submit": "Soumettre",
      "cancel": "Annuler",
      "title": "Création d’une nouvelle propriété",
      "processing": "Traitement en cours...",
      "uploadFiles": "Pièces jointes"
  }
}
</i18n>

<template>
  <b-row :class="{noActive : isProcessing }" class="list-container property">
    <div :class="{ 'no-data-message': isProcessing }" id="processing-message" class="message">
      <div class="content">
        <h4 class="align-center">
          <slot name="Loading">{{ this.$i18n.t('processing') }}</slot>
        </h4>
      </div>
    </div>
    <b-col :class="{ 'no-data': isProcessing }" class="col-12">
      <form id="property" name="dynamic-validation" @submit.prevent="handleSubmitProperty">
        <PropertyFields :title="this.$i18n.t('title')" :propertyForm="propertyForm" />
        <ConceptionFields name="conceptionFields" :propertyForm="propertyForm" />
        
        <div class="panel panel-info conception-forms"> 
            <div class="panel-heading" v-on:click="uploadFileVisibilityToggle()">
              {{ $t('uploadFiles') }}
              <div class="pull-right" v-b-toggle.filesDropzoneConceptionColl variant="primary">
                <span v-show="uploadFileVisibility">
                  <i class="fa fa-chevron-up curs"></i>
                </span>
                <span v-show="!uploadFileVisibility">
                  <i class="fa fa-chevron-down curs"></i>
                </span>
              </div>
            </div>
            <div v-show="uploadFileVisibility" class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <filesDropzoneConception name="filesDropzoneConception" :withouPanel="true" />
                </div>
              </div>
            </div>
        </div>
        <RaccordementFields name="raccordementFields" :propertyForm="propertyForm" />
        <b-row>
          <b-col cols="6"></b-col>
          <b-col cols="6" class="submit-form">
            <router-link
              class="btn btn-danger mg-r-10"
              :to="{ name: 'properties' }"
            >{{ $t('cancel') }}</router-link>
            <b-button type="submit" class="btn btn-cta s-btn">
              <b-spinner v-if="isProcessing" />
              {{ $t('submit') }}
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-col>
    <ajax-intercept @start="ajaxStart" @finish="ajaxFinish" ></ajax-intercept>  
  </b-row>
</template>

<script>
import PropertyFields from '../fields/PropertyFields.vue';
import ConceptionFields from '../fields/ConceptionFields.vue';
import RaccordementFields from '../fields/RaccordementFields.vue';
import { mapActions, mapState } from 'vuex';
import ajaxIntercept from 'vue-ajax-intercept';
import DropzoneConception from '../DropzoneConception.vue';
export default {
  name: 'propertyForm',
  components: {
    PropertyFields,
    ConceptionFields,
    RaccordementFields,
    ajaxIntercept,
    filesDropzoneConception: DropzoneConception,
  },
  data: () => ({
    isProcessing: false,
    ajaxInterceptorCounter: 0,
    uploadFileVisibility: false,
  }),
  created() {
    this.initPropertyForm();
    this.initNotif();
  },
  computed: {
    ...mapState({ propertyForm: state => state.propertyForm.propertyForm }),
  },
  methods: {
    ...mapActions(['initPropertyForm', 'initNotif']),
    handleSubmitProperty() {
      this.isProcessing = true;
      this.setFilesInFormForConception();
      this.setFilesInFormForConnection();

      // Remove extra fields
      delete this.propertyForm.technicalDrawingXml;
      delete this.propertyForm.technicalDrawingImage;
      delete this.propertyForm.synopticDrawingXml;
      delete this.propertyForm.synopticDrawingImage;

      this.$store.dispatch('handleSubmitProperty');
    },
    setFilesInFormForConnection() {
      var raccordementComponent = this.$children.find(x => x.$attrs.name === 'raccordementFields');
      var childComponents = raccordementComponent.$children.filter(x => x.$attrs.name === 'filesDropzoneConnection');

      childComponents.forEach((component, index) => {
        this.$store.dispatch('setFilesInForm', {
          component: component,
          form: this.propertyForm.raccordement.connections[index].attachement,
        });
      });
    },
    setFilesInFormForConception() {
      var dropzoneComponent = this.$children.find(x => x.$attrs.name === 'filesDropzoneConception');

      this.$store.dispatch('setFilesInForm', {
        component: dropzoneComponent,
        form: this.propertyForm.conception.attachement,
      });
    },
    ajaxStart(){
      this.ajaxInterceptorCounter++;
      this.isProcessing = true;
    },
    ajaxFinish(){
      this.ajaxInterceptorCounter--;
      if (this.ajaxInterceptorCounter <= 0) {
        this.isProcessing = false;
      }
    },
    uploadFileVisibilityToggle: function(){
      this.uploadFileVisibility = !this.uploadFileVisibility;
    },
  },
};
</script>
